// extracted by mini-css-extract-plugin
module.exports = {"errorsHolder":"ErrorPopup_errorsHolder__1YFKy"};